'use client';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { USER_QUERIES } from '../../infrastructure/user/utils/queries';

type UseGetUserMeOptions = {
  enabled?: boolean;
};

type UseGetUserOptions = {
  userId?: number;
  enabled?: boolean;
};

export const useUserService = () => {
  const useGetUserMe = ({ enabled = true }: UseGetUserMeOptions = {}) => {
    return useQuery({
      ...USER_QUERIES.getMe(),
      enabled,
    });
  };

  const useGetUser = ({ userId, enabled = true }: UseGetUserOptions = {}) => {
    return useQuery({
      ...USER_QUERIES.getUser({ userId: userId! }),
      enabled: enabled && Boolean(userId),
    });
  };

  return {
    useGetUserMe,
    useGetUser,
  };
};

export const useUserMutation = () => {
  const useGetUserMeMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(USER_QUERIES.getMeMutation(queryClient));
  };

  const useGetUserMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(USER_QUERIES.getUserMutation(queryClient));
  };

  const useUpdateUserMutation = () => {
    return useMutation(USER_QUERIES.updateUserMutation());
  };

  return {
    useGetUserMeMutation,
    useGetUserMutation,
    useUpdateUserMutation,
  };
};
